// Healthcare Skills organized by subcategories
export const HEALTHCARE_SKILLS_CATEGORIES = [
  {
    name: 'Clinical Care',
    skills: [
      'Patient Assessment', 'Diagnostic Procedures', 'Treatment Planning',
      'Medical Procedures', 'Patient Monitoring', 'Clinical Documentation',
      'Care Coordination', 'Emergency Response', 'Wound Care',
      'Medication Administration', 'Vital Signs', 'Pain Management',
      'Infection Control', 'Patient Education', 'Clinical Guidelines'
    ]
  },
  {
    name: 'Medical Knowledge',
    skills: [
      'Anatomy', 'Physiology', 'Pathology',
      'Pharmacology', 'Medical Terminology', 'Disease Management',
      'Clinical Protocols', 'Evidence-based Practice', 'Medical Research',
      'Diagnostic Methods', 'Treatment Options', 'Drug Interactions',
      'Medical Conditions', 'Health Assessment', 'Clinical Guidelines'
    ]
  },
  {
    name: 'Healthcare Technology',
    skills: [
      'Electronic Health Records', 'Medical Software', 'Telemedicine',
      'Medical Devices', 'Digital Health', 'Health Informatics',
      'Data Management', 'Technology Integration', 'System Navigation',
      'Digital Documentation', 'Remote Monitoring', 'Healthcare Apps',
      'Technology Training', 'Data Security', 'Innovation Implementation'
    ]
  },
  {
    name: 'Patient Care',
    skills: [
      'Patient Communication', 'Empathy', 'Cultural Sensitivity',
      'Patient Education', 'Care Planning', 'Support Services',
      'Family Communication', 'Patient Advocacy', 'Emotional Support',
      'Behavioral Management', 'Crisis Intervention', 'Care Coordination',
      'Patient Safety', 'Quality Care', 'Patient Experience'
    ]
  },
  {
    name: 'Healthcare Administration',
    skills: [
      'Healthcare Management', 'Policy Implementation', 'Staff Supervision',
      'Resource Management', 'Quality Assurance', 'Regulatory Compliance',
      'Budget Management', 'Program Development', 'Performance Monitoring',
      'Risk Management', 'Facility Operations', 'Strategic Planning',
      'Process Improvement', 'Documentation Management', 'Team Leadership'
    ]
  },
  {
    name: 'Public Health',
    skills: [
      'Health Promotion', 'Disease Prevention', 'Community Health',
      'Population Health', 'Health Education', 'Epidemiology',
      'Environmental Health', 'Health Policy', 'Program Planning',
      'Research Methods', 'Data Analysis', 'Health Assessment',
      'Intervention Design', 'Evaluation Methods', 'Community Engagement'
    ]
  },
  {
    name: 'Mental Health',
    skills: [
      'Psychological Assessment', 'Counseling', 'Crisis Intervention',
      'Treatment Planning', 'Behavioral Health', 'Mental Health Education',
      'Support Services', 'Case Management', 'Group Therapy',
      'Family Therapy', 'Addiction Treatment', 'Recovery Support',
      'Risk Assessment', 'Documentation', 'Care Coordination'
    ]
  },
  {
    name: 'Healthcare Quality',
    skills: [
      'Quality Assurance', 'Performance Improvement', 'Patient Safety',
      'Risk Management', 'Compliance Management', 'Quality Metrics',
      'Audit Management', 'Standards Implementation', 'Best Practices',
      'Process Improvement', 'Outcome Measurement', 'Documentation Review',
      'Quality Training', 'Safety Protocols', 'Performance Monitoring'
    ]
  },
  {
    name: 'Research and Development',
    skills: [
      'Clinical Research', 'Data Collection', 'Research Design',
      'Statistical Analysis', 'Literature Review', 'Protocol Development',
      'Study Management', 'Research Ethics', 'Grant Writing',
      'Publication Writing', 'Research Compliance', 'Data Management',
      'Result Analysis', 'Research Presentation', 'Innovation Development'
    ]
  },
  {
    name: 'Healthcare Education',
    skills: [
      'Staff Training', 'Patient Education', 'Program Development',
      'Curriculum Design', 'Teaching Methods', 'Learning Assessment',
      'Resource Development', 'Competency Assessment', 'Continuing Education',
      'Skills Training', 'Knowledge Transfer', 'Educational Planning',
      'Performance Evaluation', 'Training Documentation', 'Program Evaluation'
    ]
  },
  {
    name: 'Emergency Medicine',
    skills: [
      'Emergency Response', 'Trauma Care', 'Critical Care',
      'Triage Management', 'Life Support', 'Emergency Procedures',
      'Crisis Management', 'Rapid Assessment', 'Team Coordination',
      'Emergency Protocols', 'Equipment Operation', 'Patient Stabilization',
      'Emergency Transport', 'Documentation', 'Risk Management'
    ]
  },
  {
    name: 'Healthcare Compliance',
    skills: [
      'Regulatory Compliance', 'Policy Development', 'Standards Implementation',
      'Audit Management', 'Risk Assessment', 'Documentation Management',
      'Training Development', 'Quality Control', 'Compliance Monitoring',
      'Process Improvement', 'Reporting Systems', 'Investigation Management',
      'Corrective Action', 'Policy Review', 'Compliance Education'
    ]
  }
];

// Export flattened list for backward compatibility
export const HEALTHCARE_SKILLS = HEALTHCARE_SKILLS_CATEGORIES.reduce(
  (acc, category) => [...acc, ...category.skills],
  [] as string[]
);
